// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_style_card__3L27I","btnBox":"Card_style_btnBox__3D_9F"};